import type { PropType } from "vue";

import type { ClassQuiz } from "@/common/types/vocab";

export const useClassQuizComponent = () => {
  const commonProps = {
    classQuiz: {
      type: Object as PropType<ClassQuiz>,
      required: true
    },
    disableContinue: {
      type: Boolean,
      required: true
    }
  };

  const commonEmits = ["startQuiz", "continue"];

  return { commonProps, commonEmits };
};
